import React,{Component} from 'react'
import {Link} from 'react-router-dom'
import {jobDescriptionData,aboutHubbler} from '../data/jobDescriptionData'
import List from '../components/List'
import {Popup,PopupButton,PopupBody} from '../components/common/Popup'
import toArray from 'lodash/toArray'
import pick from 'lodash/pick'
import axios from "axios";
import ActiveWrapper from '../components/common/ActiveWrapper'
import {getDomain,getCall,postCall} from '../components/common/domain'



let regix = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

class DescriptionListItem extends Component{
    render(){
        const {name,requirements = []} = this.props.itemData
        return <li>
            <div className={'name'}>{name}</div>
            <ul>{requirements.map(item=><li>{item}</li>)}</ul>
        </li>
    }
}

export default class JobDescription extends Component{
    state = {
        loading:false,
        email:'',
        mobile:'',
        name:'',
        uploadLoading:false,
        file_paths:[],
        file_name:'',
        domain:'',
        form_submit:false,
        mainLoading:true
    }
    getJobDescription(){
        const {id} = this.props.urlData;
        this.setState({
            mainLoading:true
        });
        getCall(`/hubbler/job-responsibilites/${id}/`).then((response)=>{
            if(response.data.success){
                this.setState({
                    mainLoading:false,
                    jobDescription: response.data.result
                });
            }else {
                alert(response.data.error)
            }
        })

    }
    componentDidMount(){
       this.getJobDescription()
    }
    onChangeHandler(name,event){
        this.setState({
            [name]:event.target.value,
        })
    }
    onSubmit(name){
        const postData = pick(this.state,['email','mobile','name','file_paths','referred_by']);
        postData.designation = name;
        this.setState({
            loading:true
        })
        postCall('/hubbler/apply/',postData).then((response)=>{
            if(response.data.success){
                this.setState({
                    loading:false,
                    email:'',
                    mobile:'',
                    name:'',
                    file_paths:[],
                    file_name:'',
                    form_submit:true
                })
            }else {
                alert(response.data.error)
            }
        })
    }
    submitValidate(){
        const {name,email,mobile,file_paths} = this.state;
        const checkFormat = regix.test(this.state.email);
        return name !== '' && (email !== '' && checkFormat) && mobile !== '' && file_paths.length !==0
    }
    uploadFiles(event){
        const self = this
        const formData = new FormData();
        const files = event.target.files;
        const accept = event.target.id;
        toArray(files).map(file => {
            formData.append(file.name, file);
            formData.append('size', file.size);
        });
        axios.post(`${getDomain()}/hubbler/upload-resume/`, formData)
            .then(function (response) {
                if(response.data.success){
                    self.setState({
                        uploadLoading:false,
                        file_paths:response.data.result,
                        file_name:files[0].name
                    })
                }else {
                    alert(response.data.error)
                }

            })
            .catch(function (error) {
                console.log(error);
            });
    }
    closeFileHandler(){
        this.setState({
            file_paths:[],
            file_name:''
        })
    }
    closePopup(){
        this.setState({
            file_paths:[],
            file_name:'',
            email:'',
            mobile:'',
            name:'',
            form_submit:false
        })
        this.popupref.closePopup()
    }
    onShowHomePage(){
        this.popupref.closePopup()
        this.props.history.push('/')
    }
    render(){
        if(this.state.mainLoading){
            return <div className={'job-description-page'}>
                <div className={'loading'}></div>
            </div>
        }
        const checkFormat = regix.test(this.state.email);
        const {name,locations,department,role_and_responsibilities,detailsList,overview} = this.state.jobDescription;
        const {point1,point2} = aboutHubbler
        return <div className={'job-description-page'}>
            <div className={'header-list'}>
                <Link to={'/career'}>Careers</Link>
                /
                <Link to={{ pathname: `/career/`, search: `view=openPositions`}}>{department}</Link>
                /
                <a>{name}</a>
            </div>
            <div className={'head'}>{name}</div>
            <div className={'location'}>{locations.toString()}</div>
            <div className={'job-description-page-sub'}>
                <div className={'job-description'}>
                    {overview ?
                        <div className={'role_and_responsibilities'}>
                            <div className={'name'}>Overview</div>
                            <p className={'description'}>{overview}</p>
                        </div> : ''}
                    {role_and_responsibilities ?
                    <div className={'role_and_responsibilities'}>
                        <div className={'name'}>Role and Responsibilities</div>
                        <p className={'description'}>{role_and_responsibilities}</p>
                    </div> : ''}
                    <List items={detailsList} listItem={DescriptionListItem} className={'description-list'}/>
                    <Popup ref={popup=>this.popupref=popup }>
                        <PopupButton>
                            <a className={'apply-now'}>Apply Now</a>
                        </PopupButton>
                        <PopupBody className={'apply-now-popup-body'}>
                            <div>
                            <ActiveWrapper active={!this.state.form_submit}>
                                <div className={'apply-now-popup form-page-container'}>
                                    <div className={'header-cls'}>Apply form  <span className={'close'} onClick={()=>this.closePopup()}></span>
                                    </div>
                                    <span className={'close'}></span>
                                    <div className={'form-inputs-container'}>
                                        <div className={'inputs-list'}>
                                            <div className={'inputs'}>
                                                <label>Name <b>*</b></label>
                                                <input type="text" placeholder={'e.g., John Smith'} autoFocus={true} onChange={this.onChangeHandler.bind(this,'name')} disabled={this.state.loading ? true :false}/>
                                            </div>
                                            <div className={'inputs'}>
                                                <label>Email ID <b>*</b></label>
                                                <input type="email" placeholder={'name@company.com'} onChange={this.onChangeHandler.bind(this,'email')} disabled={this.state.loading ? true :false} className={'email-focus'}/>
                                                {(checkFormat || this.state.email === '') ? '' : <span className={'text-danger'}>email format is not correct</span>}
                                            </div>
                                            <div className={'inputs'}>
                                                <label>Phone No <b>*</b></label>
                                                <input type="number" placeholder={'+91 9988 766 554'} onChange={this.onChangeHandler.bind(this,'mobile')} disabled={this.state.loading ? true :false}/>
                                            </div>
                                            <div className={'inputs applying'}>
                                                <label>Applying for </label>
                                                <div className={'name'}>{name}</div>
                                            </div>
                                            <div className={'inputs'}>
                                                <label>Referred by</label>
                                                <input type="text" placeholder={'Please Enter Employee Name'} onChange={this.onChangeHandler.bind(this,'referred_by')} disabled={this.state.loading ? true :false}/>
                                            </div>
                                            <div className={'inputs'}>
                                                <label>Resume <b>*</b></label>
                                                {this.state.file_name ? <div className={'file-name'}>{this.state.file_name} <span className={'close'} onClick={this.closeFileHandler.bind(this)}></span></div> : ''}
                                                <div className={'resume'}>
                                                    {this.state.file_name ? '' : <label htmlFor='files2' className="btn">Upload file</label>}
                                                    {this.state.file_name ? '' :<input id='files2' style={{visibility:'hidden'}} type="file" onChange={this.uploadFiles.bind(this)} accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel, application/pdf" disabled={this.state.loading ? true :false}/>}
                                                </div>
                                            </div>
                                        </div>
                                        <div className={'footer'}>
                                            <button className={'cancel'} onClick={()=>this.closePopup()}>Cancel</button>
                                            <button className={this.submitValidate() ? 'submit bt-blue' : 'submit bt-blue disable'} id={this.state.loading ? 'bt-loading' : ''} onClick={this.onSubmit.bind(this,name)}>Submit</button>
                                        </div>
                                    </div>
                                </div>
                            </ActiveWrapper>
                                <ActiveWrapper active={this.state.form_submit}>
                                    <div className={'apply-now-popup'}>
                                        <div className={'header-cls thanks'}><span className={'close'} onClick={()=>this.closePopup()}></span></div>
                                            <div className={'thanks-ui form-page-container'}>
                                            <div className={'head'}>Thank you for Applying.</div>
                                            <p>Our team will get back to you soon. </p>
                                                <a onClick={this.onShowHomePage.bind(this)}>Take me back to home page</a>
                                        </div>
                                    </div>
                                </ActiveWrapper>
                            </div>
                        </PopupBody>
                    </Popup>
                </div>
                <div className={'about-hubbler'}>
                    <div className={'name'}>About Hubler</div>
                    <p>{point1}</p>
                    <p>{point2}</p>
                </div>
            </div>
        </div>
    }
}


// WEBPACK FOOTER //
// ./src/components/JobDescription.js